const base_routes = [
  {
      path: "*",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/Login/Login"),
    },
      /* 资质上传页面*/
    {
      path:"/qualification",
      name:'Qualification',
      component:()=> import("@/components/Qualification/addQualification"),
    },
    {
      path:"/dishonestPeopleAppealAdd",
      name:'Qualification',
      component:()=> import("@/components/DishonestPeopleAppealAdd/DishonestPeopleAppealAdd"),
    },
    /* 资质修改页面*/
    {
      path:"/editQualification",
      name:'EditQualification',
      component:()=> import("@/components/Qualification/edit-qualification"),
    },
    /* 查看资质审核页面*/
    {
      path:"/lookQualification",
      name:'lookQualification',
      component :() => import('@/views/system_manager/review/record'),
    },
    {
      path: "/findpwd",
      name: "FindPhonePwd",
      component: () => import("@/views/Login/FindPhonePwd"),
    },
    //  查询证书页面 首页
    {
      path: "/search",
      name: "Search",
      component: () => import("@/views/search/SearchIndex"),
    },
    //  查询证书页面 十一人制
    {
      path: "/search_eleven",
      name: "SearchEleven",
      component: () => import("@/views/search/Search"),
    },
    //  查询证书页面 五人制
    {
      path: "/search_five",
      name: "SearchFive",
      component: () => import("@/views/search/SearchFive"),
    },
    {
      path: "/achievement",
      name: "Enquiries",
      component: () => import("@/views/Achievement/Enquiries"),
    },
  {
    path: "/achievementFive",
    name: "EnquiriesFive",
    component: () => import("@/views/Achievement/EnquiriesFive"),
  },
    // 查询证书手机端页面, d级查询
    {
      path: "/search-grade-d",
      name: "GradeD",
      component: () => import("@/views/search/grade_d"),
    },
    // 查询证书手机端页面, 岗位查询
    {
      path: "/search-grade-g",
      name: "GradeG",
      component: () => import("@/views/search/grade_g"),
    },
    // 查询证书手机端页面, pabc级查询
    {
      path: "/search-grade-pabc",
      name: "GradePABC",
      component: () => import("@/views/search/grade_pabc"),
    },
  {
    path: "/search-grade-five",
    name: "GradeFive",
    component: () => import("@/views/search/grade_five"),
  },
    //部分人员注册页面
    {
      path: "/register",
      name: "high_end_register",
      component: () => import("@/views/High-EndRegister/high_end_register"),
    },
    // {
    //   path: "/registrationList",
    //   name: "RegistrationList",
    //   component: () => import("@/views/Registration/registration-list"),
    // },
    {
      path: "/hign_register",
      name: "HignRegister",
      component: () => import("@/views/Registration/HignRegister"),
    },
    {
      path: "/hign_register_new",
      name: "HignRegisterNew",
      component: () => import("@/views/Registration/HignRegisterNew"),
    },
    {
      path: "/letDownList",
      name: "letDownList",
      component: () => import("@/views/LetDown/letDownList"),
    },
    {
      path: "/coachAppealInfo",
      name: "coachAppealInfo",
      component: () => import("@/views/LetDown/appealInfo"),
    },

    /*{
      path: "/permission",
      name: "Permission",
      component: () => import("@/components/Tips/Permission"),
    },*/
    {
      path: "/permission",
      name: "Permission",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        {
          path: 'forbid',
          component: () => import("@/components/Tips/Permission"),
          meta: {requiresAuth: true},
        },
      ]
    },
    /*{
      path: "/home",
      name: "Home",
      component: () => import("@/views/Home/Home"),
      meta: { requiresAuth: true }
    },*/
  
  {
    path: "/integrationIndex",
    name: "IntegrationIndex",
    component: () => import("@/views/Login/integrationIndex"),
  },
]

export default base_routes;
